import { DetailsListItem } from '#/components/DetailsList/Item/DetailsListItem';
import { useI18n } from '#/i18n/hooks/useI18n';
import type {
  IanaTimezone,
  DateString,
  TimeString,
} from '#/types/TypedDateString';

import { ListingDateAndTime } from './ListingDateAndTime';

type Props = {
  startDate: DateString;
  startTime: TimeString | null;
  endDate: DateString | null;
  endTime: TimeString | null;
  timezone: IanaTimezone | null;
};

export function ListingDateDetailsListItems({
  startDate,
  startTime,
  endDate,
  endTime,
  timezone,
}: Props) {
  const { i18n } = useI18n();

  if (startDate === endDate) {
    return (
      <DetailsListItem
        title={i18n('Date')}
        iconName="calendar"
        value={
          <ListingDateAndTime
            date={startDate}
            time={(() => {
              if (!startTime || !timezone) return null;

              return endTime
                ? { type: 'range', start: startTime, end: endTime, timezone }
                : { type: 'single', value: startTime, timezone };
            })()}
          />
        }
      />
    );
  }

  return (
    <>
      <DetailsListItem
        title={i18n('Start Date')}
        iconName="hourglass"
        value={
          <ListingDateAndTime
            date={startDate}
            time={
              startTime && timezone
                ? { type: 'single', value: startTime, timezone }
                : null
            }
          />
        }
      />

      {endDate && (
        <DetailsListItem
          title={i18n('End Date')}
          iconName="hourglass"
          value={
            <ListingDateAndTime
              date={endDate}
              time={
                endTime && timezone
                  ? { type: 'single', value: endTime, timezone }
                  : null
              }
            />
          }
        />
      )}
    </>
  );
}
